// Shared helper classes for element attributes
import {asTimeOnly} from '@/components/DateTime';
import {TRACK_HIDDEN} from '@/views/calendar/config';
import { isAppointment, isDeleted } from "./Filter";
import {FLAGS} from '@/utils/Item';

export const itemTrackClasses = (appointment) => {
    // Used with Calendar Items that may have an embedded track
    if (!isAppointment(appointment)) { return ''; }

    if (appointment.track_id) {
        return `track${appointment.track_id} track-order${appointment.track_order} ${appointment.track_name===TRACK_HIDDEN ? 'track-hidden':''}`;
    } else {
        return "track0 track-order0";
    }
}

export const trackClasses = (track) => {
    // Similar logic to trackClasses(), but used when you actually have a Track object
    if (track.id == 'my') { return ''; }
    if (track.id > 0) {
        return `track${track.id} track-order${track.order_weight} ${track.name===TRACK_HIDDEN ? 'track-hidden':''}`;
    } else {
        return "track0 track-order0";
    }
}

// Calculate the correct class names for the given appointment/meeting
export const itemClasses = (item) => {
    let out = `calendar-item-meeting meeting-id${item.id}`;
    if (isAppointment(item)) {
        out = `calendar-item-appointment  appointment-id${item.id}`;

        if (item.in_schedule) {
            out += ' calendar-item-pinned';
        }
        if (item.track_name === TRACK_HIDDEN) {
            out += ' calendar-item-track-hidden';
        }
    } else {
        if (item.flags.includes(FLAGS.CONFIRMED)) {
            out += ' calendar-item-meeting-confirmed';
        } else if (item.flags.includes(FLAGS.INBOUND)) {
            out += ' calendar-item-meeting-inbound';
        } else if (item.flags.includes(FLAGS.OUTBOUND)) {
            out += ' calendar-item-meeting-outbound';
        }

        // Add BOTH groups. Don't worry about duplicate classes.
        if (item.attendee_group_id) {
            out += ` calendar-item-group${item.attendee_group_id}`;
        }
        if (item.booker_group_id) {
            out += ` calendar-item-group${item.booker_group_id}`;
        }
    }

    if (isDeleted(item)) {
        out += ' calendar-item-cancelled';  // TODO: Change to '-deleted'?
    }
    return out;
};

export const itemTitle = (item, timezone) => {
    if (isAppointment(item)) {
        return `${item.name} : ${asTimeOnly(item.startObj, timezone)} - ${asTimeOnly(item.endObj, timezone)}`;
    } else {
        return `${item.other_name} : ${asTimeOnly(item.startObj, timezone)} - ${asTimeOnly(item.endObj, timezone)}`;
    }
};